var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BCA042CE-8EBC-413F-8E31-7588525A205F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.46765449,20.8460802 L4.36567911,20.3205864 C4.40588147,20.1597769 4.4810749,19.8965999 4.59205157,19.5636699 C4.77642608,19.0105464 4.99803655,18.4565202 5.26020401,17.9321853 C6.10379981,16.2449936 7.18212676,15.1666667 8.66666674,15.1666667 L17.3333333,15.1666667 C18.8178732,15.1666667 19.8962002,16.2449936 20.739796,17.9321853 C21.0019635,18.4565202 21.2235739,19.0105464 21.4079484,19.5636699 C21.5189251,19.8965999 21.5941185,20.1597769 21.6343209,20.3205864 L19.5323455,20.8460802 C19.5048395,20.7360563 19.4446163,20.525275 19.352468,20.24883 C19.1983008,19.7863286 19.0136613,19.3247298 18.8018704,18.901148 C18.2912996,17.8800063 17.7446266,17.3333333 17.3333333,17.3333333 L8.66666674,17.3333333 C8.25537342,17.3333333 7.7087004,17.8800063 7.19812956,18.901148 C6.98633869,19.3247298 6.80169916,19.7863286 6.64753201,20.24883 C6.55538369,20.525275 6.49516046,20.7360563 6.46765449,20.8460802 Z M17.8750003,9.20833333 C17.8750003,11.9556062 15.6954417,14.0833333 12.9560169,14.0833333 C10.2264415,14.0833333 8.12500026,11.9646887 8.12500026,9.20833333 C8.12500026,6.42446124 10.1651883,4.33333333 12.9560169,4.33333333 C15.7564255,4.33333333 17.8750003,6.43484386 17.8750003,9.20833333 Z M15.7083333,9.20833333 C15.7083333,7.63540076 14.5637131,6.5 12.9560167,6.5 C11.373927,6.5 10.2916667,7.60928242 10.2916667,9.20833333 C10.2916667,10.7720083 11.4270304,11.9166667 12.9560167,11.9166667 C14.5103403,11.9166667 15.7083333,10.7471627 15.7083333,9.20833333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Home",
    transform: "translate(-329.000000, -1163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FOOTER",
    transform: "translate(0.000000, 1147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_profile",
    transform: "translate(325.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfile);
export default __webpack_public_path__ + "static/media/ico_profile.4894c462756342668f93cf7a98f31e53.svg";
export { ForwardRef as ReactComponent };